import React from "react";
import Prose from "../../components/prose";
import GlobalLayout from "../../components/layouts/layout-global";
import SEO from "../../components/seo";
import FeatureItem from "../../components/feature-item";
import SectionDefault from "../../components/sections/section-default";
import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image";
import ToTop from "../../components/to-top";
import { Link, graphql, useStaticQuery } from "gatsby";
import { AccordionItemLite, AccordionLite } from "../../components/accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import DigitalPilotPitch from "../../components/features/hero-carousel/carousel-cards/digital-pilot-pitch";

export const Head = ({ location }) => (
  <SEO
    title="NACC & Gates Ventures AD/ADRD Digital Pilot Program"
    // prettier-ignore
    keywords={[
      "NACC", "history", "publications", "Alzheimer&apos;s", "dementia", "degeneration", "MCI", "research", "data", "NIA", "NIH", "neuropathology",
      "neurology", "gerontology", "age", "cognitive", "genetics", "APOE", "biomarkers", "pilots", "digital biomarkers", "Gates Ventures", "AD/ADRD",
    ]}
    description="NACC and Gates Ventures AD/ADRD Digital Biomarker Pilot Program"
    pathname={location.pathname}
  />
);

function JudgeCard({ name, image, institution, position, href }) {
  const data = useStaticQuery(graphql`
    {
      allFile(
        filter: { sourceInstanceName: { eq: "images" }, relativeDirectory: { in: ["digital-biomarkers/judges"] } }
      ) {
        edges {
          node {
            relativePath
            childImageSharp {
              gatsbyImageData(width: 200, placeholder: BLURRED, formats: [AUTO, WEBP])
            }
          }
        }
      }
    }
  `);
  const imageNode = data.allFile.edges.find((n) => n.node.relativePath === image);
  const gqlImage = getImage(imageNode.node.childImageSharp.gatsbyImageData);

  return (
    <div className="uk-inline">
      <a href={href} target="_blank" rel="noreferrer" className="uk-link-reset">
        <GatsbyImage
          image={gqlImage}
          alt={name}
          className="uk-object-contain match "
          style={{ height: "140px", width: "140px" }}
        />
        <ul className="uk-list uk-list-collapse uk-margin-small">
          <h6 className="uk-margin-remove">{name}</h6>
          <p className="uk-margin-remove uk-text-italic">{position}</p>
          <p className="uk-margin-remove">{institution}</p>
        </ul>
      </a>
    </div>
  );
}

const judges = [
  {
    name: "Niranjan Bose, PhD",
    image: "digital-biomarkers/judges/Bose.jpg",
    position: "Managing Director of Health and Life Sciences",
    institution: "Gates Ventures",
    href: "https://www.linkedin.com/in/niranjanbose/",
  },
  {
    name: "Barbara Tate, PhD",
    image: "digital-biomarkers/judges/Tate.jpg",
    position: "Venture Partner",
    institution: "SV Health Investors",
    href: "https://www.linkedin.com/in/barbara-t-83b8904/",
  },
  {
    name: "Shwen Gwee",
    image: "digital-biomarkers/judges/Gee.jpg",
    position: "Founder and Chief Disrupter",
    institution: "Health Disrupters Inc",
    href: "https://www.linkedin.com/in/shwen/",
  },
  {
    name: "Jason Hassenstab, PhD",
    image: "digital-biomarkers/judges/Hassenstab.jpg",
    position: "Director",
    institution: "Cognitive Technology Research Laboratory (CTRLab) at Washington University in St. Louis",
    href: "https://profiles.wustl.edu/en/persons/jason-hassenstab",
  },
  {
    name: "Rachel Sha, MBA",
    image: "digital-biomarkers/judges/Sha.jpg",
    position: "Operating Partner",
    institution: "Engine Ventures",
    href: "https://www.linkedin.com/in/rachelsha/",
  },
  {
    name: "Omkar Kulkarni, MPH",
    image: "digital-biomarkers/judges/Kulkarni.jpg",
    position: "Vice President, Chief Transformation Officer, Chief Digital Officer",
    institution: "Children’s Hospital Los Angeles, KidsX",
    href: "https://www.linkedin.com/in/opkinnovation/",
  },
  {
    name: "Hugh Chang, MBA",
    image: "digital-biomarkers/judges/Chang.jpg",
    position: "Former Director of Maternal Newborn and Child Health",
    institution: "Gates Ventures",
    href: "https://www.linkedin.com/in/hugh-n-chang/",
  },
  {
    name: "Linda Li, MBA",
    image: "digital-biomarkers/judges/Linda-Li.jpg",
    position: "Partner, Health Information Technology",
    institution: "Cleveland Clinic Innovations",
    href: "https://www.linkedin.com/in/ccflinda/",
  },

  {
    name: "Vinny Beranek, PhD",
    image: "digital-biomarkers/judges/Beranek.jpg",
    position: "Principal",
    institution: "Engine Ventures",
    href: "https://www.linkedin.com/in/vinny-beranek/",
  },
];

export default function DigitalBiomarkerPilot(props) {
  return (
    <GlobalLayout location={props.location}>
      <section className="uk-section-small uk-section-default uk-border-rounded uk-box-shadow-medium uk-margin-bottom ">
        <div
          className="uk-margin-large-left uk-margin-large-right uk-margin-remove-bottom"
          style={{ backgroundColor: "#003f7f" }}
        >
          <div className="uk-flex uk-flex-center">
            <StaticImage
              src="../../images/digital-biomarkers/header.png"
              height={280}
              alt="National Alzheimer’s Coordinating Center & Gates Ventures AD/ADRD Digital Biomarker Pilot Program"
            />
          </div>
        </div>
        <div
          className="uk-card uk-card-body uk-background-default uk-border-rounded uk-padding-remove-bottom uk-position-z-index "
          data-uk-sticky
        >
          <ul
            className="uk-subnav uk-subnav-pill uk-flex uk-flex-center uk-margin-auto"
            data-uk-scrollspy-nav="closest: li; scroll: true; offset: 54; overflow: false"
            data-uk-margin
          >
            <li>
              <a data-uk-scroll href="#about%20the%20digital%20biomarker%20pilot%20program">
                About the Program
              </a>
            </li>
            <li>
              <a data-uk-scroll href="#events">
                Events
              </a>
            </li>
            <li>
              <a data-uk-scroll href="#applicationreview">
                Application Review
              </a>
            </li>
            <li>
              <a data-uk-scroll href="#how%20to%20apply">
                How to Apply
              </a>
            </li>
            <li>
              <a data-uk-scroll href="#proposal%20body%20details">
                Proposal Body Details
              </a>
            </li>
            <li>
              <a data-uk-scroll href="#contact%20us">
                Contact Us
              </a>
            </li>
            <li>
              <a data-uk-scroll href="#partner%20information">
                Partner Information
              </a>
            </li>
            <li>
              <a data-uk-scroll href="#faqs">
                FAQs
              </a>
            </li>
          </ul>
        </div>
        <div className="uk-padding uk-padding-remove-bottom">
          <>
            <div className="announcement uk-box-shadow-small uk-margin-large-bottom uk-padding uk-margin-auto uk-padding-remove-bottom uk-background-muted uk-border-rounded text-body uk-width-1-1">
              <div className="uk-h5 uk-inline red uk-text-center">Congratulations to 2024 Award Winners!</div>
              <p className="bolder">
                Two proposals were selected for funding after a rigorous review process, with input from digital health
                experts across industry, government, and academia, culminating in a public pitch competition.
              </p>
              <div className="uk-flex uk-flex-right uk-margin-top ">
                <Link
                  to="/nacc-productivity/2024-digital-pilot-award-winners"
                  className="uk-button uk-button-primary bolder uk-text-truncate uk-margin-bottom"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  See the full announcement
                  <FontAwesomeIcon icon={faArrowRight} size="1x" className="uk-text-small uk-margin-small-left" />
                </Link>
              </div>
            </div>
          </>
          <div className="uk-flex uk-flex-middle uk-flex-column uk-padding-medium-top">
            <h2 className="uk-width-1-1 uk-margin-large-left uk-text-center">
              Missed the Pitch Competition?{" "}
              <a data-uk-scroll href="#events">
                Catch the live recording here
                <FontAwesomeIcon icon={faArrowDown} className="uk-margin-small-left" />
              </a>
            </h2>
            <hr />
            <Prose>
              <h3>Program Overview</h3>
              <p>
                Alzheimer&apos;s Disease and Related Dementias (AD/ADRD) research is entering the digital age! There is
                a huge opportunity to leverage digital tools to advance AD/ADRD research and discovery and make this
                research more comprehensive. A key focus of this award program, a partnership between Gates Ventures and
                National Alzheimer&apos;s Coordinating Center (NACC), is to accelerate the pace of digital innovation in
                AD/ADRD and to facilitate impactful collaborations between academia and industry. This award will create
                pathways for digital technology to be applied within the Alzheimer&apos;s Disease Research Centers
                (ADRC) network which serves as a model for the global AD/ADRD community. The data collected through
                these awards will be integrated with other standardized data modalities at NACC and made freely
                available to researchers everywhere. We are committed to working with awardees to scale successful
                projects across the full ADRC network and beyond. Together this data will open the door to better early
                detection, treatment, and prevention of AD/ADRD.
              </p>
            </Prose>
          </div>
          <ToTop />
        </div>
      </section>

      <SectionDefault id="about" subheading="About the Digital Biomarker Pilot Program">
        <div className="uk-flex uk-flex-middle uk-flex-column">
          <div className="uk-clearfix uk-width-2xlarge">
            <div className="text-body uk-margin-top">
              <h3>The goals of this program are to:</h3>
              <ul className="uk-list uk-list-bullet">
                <li>
                  Accelerate impactful digital data collection and sharing across the ADRC Program to advance AD/ADRD
                  research and discovery.
                </li>
                <li>
                  Leverage technology to capture richer and more objective data with less burden for participants and
                  ADRCs.
                </li>
                <li>
                  Advance the development and/or validation of digital biomarkers for early detection, diagnosis,
                  prognosis, or monitoring.
                </li>
              </ul>
              <p className="uk-text-justify">
                The selection committee will choose one to three pilot projects and award between $250,000 to $
                1,000,000 (direct costs, 15% indirect cap) for one to two-year digital pilot projects. Award amounts
                will be based on the stage and scope of the pilot projects proposed. Funding will be provided for pilot
                projects that leverage technology to enable richer and more objective data collection with less burden
                for participants and ADRCs and that advance the development and validation of digital biomarkers.
              </p>
              {/* FEATURE LIST */}
              <div className="uk-flex uk-align-center uk-flex-column uk-width-xlarge">
                <div
                  data-uk-grid="true"
                  className="uk-grid-small uk-box-shadow-small"
                  style={{ border: `1px solid #104d89`, minHeight: 64, background: "#f6f6f6", overflow: "hidden" }}
                >
                  <div className="uk-flex uk-flex-middle uk-flex-center uk-width-1-6 uk-background-default">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1"
                      stroke="#104d89"
                      style={{ paddingRight: 15, height: 48 }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div className={` bold uk-width-expand uk-text-center uk-flex uk-flex-middle uk-flex-around`}>
                    Budget
                  </div>
                  <div className="  uk-width-1-2 uk-flex uk-flex-middle uk-padding-small">
                    1-3 pilots ranging from $250K to $1M (direct costs). Award amounts will be based on the stage and
                    scope of the pilot projects proposed.
                  </div>
                </div>
                <FeatureItem fill="#104d89" icon={"future"} title={"Pilot Length"} description={"1 - 2 Years"} />
                <FeatureItem
                  fill="#104d89"
                  icon={"info"}
                  title={"Eligibility"}
                  description={
                    "Funding is open to any ADRC or non-ADRC groups or companies. Applicants must have multiple (two or more) ADRC collaborators to be considered."
                  }
                />
              </div>
              <div>
                <h3>Data Sharing Requirements</h3>
                <p>
                  All data generated or used in each pilot project must be made accessible to the research community
                  through the National Alzheimer&apos;s Coordinating Center (NACC) Data Platform.
                </p>
                <p className="uk-text-italic">
                  <span className="bolder">Please note:</span> Pilot projects and their partnering companies are
                  expected to share raw digital data files with NACC.
                </p>
              </div>
            </div>
          </div>
          <>
            <div data-uk-grid className="uk-grid uk-grid-small uk-flex-center uk-margin-bottom text-body">
              <div className="uk-width-1-3@m uk-card uk-card-body">
                <div style={{ border: "1px solid #104D89" }}>
                  <div style={{ backgroundColor: "#104D89" }}>
                    <div className="uk-card-title text-white uk-margin-left">Pilot Project Requirements</div>
                  </div>
                  <ul className="uk-list uk-list-bullet uk-padding-small uk-margin-remove-top">
                    <li>Add research value and enhances metrics</li>
                    <li>
                      Reduce burden: projects must demonstrate how they will reduce burden on patients and/or providers
                      and medical center staff
                    </li>
                    {/* <li>Expand accessibility/reach and addresses diversity</li> */}
                    <li>Involves multiple ADRCs</li>
                    <li>Demonstrates scalability (ADRCs and beyond)</li>
                    <li>Be amenable to open science experiments such as data challenges down the line</li>
                    <li>
                      Partnering companies must provide the raw digital files to NACC (some raw data required, companies
                      may still protect IP as needed)
                    </li>
                  </ul>
                </div>
              </div>
              <div className="uk-width-1-3@m uk-card uk-card-body">
                <div style={{ border: "1px solid #104D89" }}>
                  <div style={{ backgroundColor: "#104D89" }}>
                    <div className="uk-card-title text-white uk-margin-left">Example Modalities</div>
                  </div>
                  <ul className="uk-list uk-list-bullet uk-padding-small uk-margin-remove-top">
                    <li>Sleep</li>
                    <li>Movement and/or Phone gyroscope measures</li>
                    <li>Fall detection</li>
                    <li>Mood State</li>
                    <li>Speech</li>
                    <li>Video</li>
                    <li>Language</li>
                    <li>Eye tracking</li>
                    <li>
                      Digitized UDS <Link to="/data-collection/forms-documentation/uds-3">(Uniform Data Set)</Link> and
                      non-UDS
                    </li>
                    <li>Diet</li>
                    <li>Driving</li>
                    <li>Keystrokes</li>
                  </ul>
                </div>
              </div>
              <div className="uk-width-1-3@m uk-card uk-card-body">
                <div style={{ border: "1px solid #104D89" }}>
                  <div style={{ backgroundColor: "#104D89" }}>
                    <div className="uk-card-title text-white uk-margin-left">Example Tools</div>
                  </div>
                  <ul className="uk-list uk-list-bullet uk-padding-small uk-margin-remove-top">
                    <li>Wearables devices (e.g. smart watch)</li>
                    <li>Single-Sensors</li>
                    <li>Multi-sensor</li>
                    <li>Mobile/tablet apps</li>
                    <li>Smart home systems</li>
                    <li>Virtual and augmented reality platforms</li>
                    <li>Desktop/web apps</li>
                    <li>Deep machine learning-AI-driven Algorithms</li>
                    <li>Single Digital Modality Processing Software</li>
                    <li>Multi-Digital Modality Processing Software</li>
                    <li>Large Language Models</li>
                  </ul>
                </div>
              </div>
              <div className="uk-width-1-2@s">
                <h3>Timeline</h3>
                <ul className="uk-list uk-list-bullet uk-margin-small-left">
                  <li>
                    <span className="bolder">October 19, 2023:</span> RFA Announced and Applications period opens
                  </li>
                  <li>
                    <span className="bolder">February 21, 2024:</span> Deadline for applications
                  </li>
                  <li>
                    <span className="bolder">March - April 2024:</span> Applications reviewed by selection committee
                  </li>
                  <li>
                    <span className="bolder">May 2024:</span> Pitch Competition
                  </li>
                  <li>
                    <span className="bolder">May - June 2024:</span> One to three winners are selected, and funding is
                    awarded via NACC
                  </li>
                  <li>
                    <span className="bolder">Summer 2024:</span> Pilot projects are launched (pilot length one to two
                    years)
                  </li>
                </ul>
              </div>
              <div className="uk-width-1-2@s">
                <h3>Potential for follow-up support</h3>
                <ul className="uk-list uk-list-bullet uk-margin-small-left">
                  <li>
                    Promising digital pilot projects may be scaled to the full ADRC program and eligible for follow-on
                    funding via NACC&apos;s U24 renewal.
                  </li>
                  <li>Funded Data Challenge using data collected from the pilots selected for funding.</li>
                  <li className="">
                    <a href="https://www.nia.nih.gov/research/sbir" title="NIA Small Business Programs (SBIR & STTR)">
                      SBIR/STTR
                      <StaticImage
                        class="uk-margin-small-left"
                        src="../../images/digital-biomarkers/sbir-logo.png"
                        alt="SBIR/STTR Logo"
                        height={100}
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.alzdiscovery.org/research-and-grants/diagnostics-accelerator"
                      title="AD Diagnostics Accelerator"
                    >
                      AD Diagnostics Accelerator
                      <StaticImage
                        className="uk-margin-small-left"
                        src="../../images/digital-biomarkers/addf_logo_web.png"
                        alt="ADDF Logo"
                        height={100}
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </>
        </div>
        <ToTop />
      </SectionDefault>

      <SectionDefault id="events" subheading="Events">
        <h3>AD/ADRD Digital Pilot Program Pitch Competition</h3>
        <Prose>
          <DigitalPilotPitch />
          <h4>About the Pitch Competition:</h4>
          <p>
            Top applicants of the NACC and Gates Ventures Alzheimer&apos;s Disease and Related Dementias (AD/ADRD)
            Digital Pilot Program pitched their proposals to the judge panel in front of a live audience. In pursuit of
            $250K-$1M in funding, these top teams shared how their pilot projects will leverage digital tools to enable
            richer and more objective data collection across the ADRC Program and beyond with less burden for research
            subjects and patients.
          </p>
          <p>
            This event was an excellent opportunity to learn about emerging digital solutions and how digital data
            collection is transforming AD/ADRD research and discovery.
          </p>
        </Prose>
        <div className="uk-grid uk-grid-small uk-margin-bottom uk-child-width-1-2@m" data-uk-grid>
          <div>
            <iframe
              src="https://www.youtube-nocookie.com/embed/do5gdzI4Roo?start=0?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=0"
              width="1920"
              height="1080"
              allowfullscreen
              data-uk-responsive
              data-uk-video="false"
            ></iframe>
          </div>
          <div>
            <h4>View the pitching teams slides: </h4>
            <ul className="uk-list uk-list-bullet">
              <li>
                <a
                  href="
                https://files.alz.washington.edu/digital-pilot-program/pitch-decks/kaye-pitch-deck.pdf"
                >
                  EFFECT-AD - Everyday Frequent Functional Evaluation with Crosscutting Technology for AD
                </a>
              </li>
              <li>
                <a href="https://files.alz.washington.edu/digital-pilot-program/pitch-decks/winer-pitch-deck.pdf">
                  Characterizing sleep-wake activity patterns across the spectrum of AD/ADRD
                </a>
              </li>
              <li>
                <a href="https://files.alz.washington.edu/digital-pilot-program/pitch-decks/moore-pitch-deck.pdf">
                  CLARIFY - Speech Analysis and Keystroke Tracking for Early AD Detection
                </a>
              </li>
              <li>
                <a href="https://files.alz.washington.edu/digital-pilot-program/pitch-decks/adeli-pitch-deck.pdf">
                  Scalable Next-Generation Smartphone Gait Assessment for Early Detection of AD/ADRD
                </a>
              </li>
              <li>
                <a href="https://files.alz.washington.edu/digital-pilot-program/pitch-decks/rhodes-pitch-deck.pdf">
                  Remote Digital Monitoring to Detect Behavioral and Neuropsychiatric Symptoms in ADRD
                </a>
              </li>
              <li>
                <a href="https://files.alz.washington.edu/digital-pilot-program/pitch-decks/vickers-pitch-deck.pdf">
                  Pilot Study to Evaluate VisMET on the Linus Health Platform at Multiple ADRCs
                </a>
              </li>
            </ul>
          </div>
        </div>
        <Prose>
          <h4>The 6 Finalist Teams</h4>
          <div className="uk-flex uk-flex-center uk-width-1-1">
            <StaticImage src="../../images/digital-biomarkers/dp-finalists.png" alt="6 Finalist Teams" height={750} />
          </div>
        </Prose>
        <div
          className="uk-grid uk-grid-small uk-child-width-1-2@m uk-margin-large-top text-body uk-grid-divider"
          data-uk-grid="true"
        >
          <div>
            <h4>What to expect</h4>
            <ul className="uk-list uk-list-bullet">
              <li>Pitching teams were given 6 minutes to pitch their proposals</li>
              <li>
                Pitches were followed by 4 minutes of Q&A from our panel of expert judges made up of digital health
                leaders from across the academic, industry, and government sectors.
              </li>
              <li>
                At the end of the event, audience members joined an “Ask Me Anything” Virtual Poster Session where they
                metwith the pitching teams to ask questions and learn more about their projects.
              </li>
            </ul>
          </div>

          <div>
            <h4>Event Agenda - Full Agenda</h4>
            <ul className="uk-list uk-list-bullet">
              <li>
                <span className="bolder">15min</span> Event start and introduction
              </li>
              <li>
                <span className="bolder">70min</span> Pitch Competition: two 30min parts with a 10min break
              </li>
              <li>
                <span className="bolder">15min</span> Event end and closing remarks
              </li>
              <li>
                <span className="bolder">10min</span> Break
              </li>
              <li>
                <span className="bolder">40min</span> &quot;Ask me anything&quot; Virtual Poster Session
              </li>
            </ul>
          </div>
        </div>
        <h4>Judge Panel</h4>
        <div>
          <div className="uk-flex uk-flex-center uk-margin-large-top uk-margin-large-bottom">
            <div>
              <h5>Event Moderator</h5>
              <JudgeCard
                name="Jessica Roberto, PhD"
                image="digital-biomarkers/judges/Roberto.jpg"
                href="https://www.linkedin.com/in/jessicabroberto/"
                institution={"UW Buerk Center for Entrepreneurship"}
                position={"Assistant Director, Health Innovation Challenge"}
              />
            </div>
          </div>
          <div
            className="uk-grid uk-grid-small uk-child-width-1-2@s uk-child-width-1-3@m uk-grid-divider uk-margin-large-top uk-margin-large-bottom"
            data-uk-grid="true"
          >
            {judges.map((judge) => (
              <JudgeCard
                key={judge.name}
                name={judge.name}
                image={judge.image}
                href={judge.href}
                institution={judge.institution}
                position={judge.position}
              />
            ))}
          </div>
        </div>

        <hr />
        <h3>
          Informational Webinar on the NACC & Gates Ventures AD/ADRD Digital Biomarker Pilot Program - January 22, 2024
        </h3>

        <div className="" data-uk-grid="true">
          <div className="uk-width-1-2@m">
            <StaticImage
              src="../../images/digital-biomarkers/webinar-announcement.png"
              alt="Digital Biomarkers Pilot Webinar"
              height={480}
            />
          </div>
          <div className="uk-width-1-2@m">
            <iframe
              src="https://www.youtube-nocookie.com/embed/hu5WY6qX7r0?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=0"
              width="1920"
              height="1080"
              allowfullscreen
              data-uk-responsive
              data-uk-video="false"
            ></iframe>
            {/* view slides here button */}
            <div className="uk-flex uk-flex-right uk-margin-top uk-margin-large-bottom">
              <a
                href="https://files.alz.washington.edu/webinars/slides-1.22.24-digital-pilot-program-webinar.pdf"
                className="uk-button uk-button-primary"
              >
                View Slides Here
                <FontAwesomeIcon icon={faArrowRight} className="uk-margin-small-left" />
              </a>
            </div>
          </div>
          <Prose>
            <p>
              The webinar featured an overview of the new program launched by NACC and Gates Ventures and the value that
              this data will have on AD/ADRD research and innovation! Our speakers Niranjan Bose, PhD of Gates Ventures,
              Nina Silverberg, PhD of NIA, Rhoda Au, PhD, MBA of Boston University, and Sarah Biber, PhD of NACC covered
              highly relevant topics such as how to connect with industry partners from an academic lens and why the
              ADRC Program is a good testbed for developing impactful digital biomarkers. This webinar wrapped up with a
              Q&A panel - which has been included in the FAQ section.
            </p>
          </Prose>
        </div>
        <ToTop />
      </SectionDefault>

      <SectionDefault id="applicationreview" subheading="Application Review">
        <Prose>
          <p>
            Our goal is to provide applicants with high-standard, professional assessments of scientific appraisals. The
            multi-stage process described below is designed to ensure both scientific rigor and fairness in the review
            of all submitted applications.
          </p>
          <h3>Review / Selection Process</h3>
          <ol className="uk-list uk-list-decimal">
            <li>
              <p>
                <span className="bolder">Prescreening: </span> All applications will be pre-screened to ensure that they
                meet the minimum selection criteria (at least 2 ADRC collaborators, reduces burden on patients and/or
                staff, agrees to data sharing via NACC, budget is within RFA scope, etc.)
              </p>
            </li>
            <li>
              <p>
                <span className="bolder">Review Committee:</span> Each proposal will be reviewed by at least 2-3
                committee members and assigned scores. After initial scores are assigned, reviewers will discuss and
                determine which applicants will be invited to the next stage of the review process.
              </p>
            </li>
            <li>
              <p>
                <span className="bolder">Pitch Competition:</span> The top proposal teams (5-10 applications) will be
                invited to participate in a pitch competition. Selection committee members will attend and discuss each
                team&apos;s pitch to assign final scores and make funding recommendations.
              </p>
            </li>
            <li>
              <p>
                <span className="bolder">Awardees Selected:</span> NACC and Gates Ventures will determine final funding
                decisions for 1-3 winning proposals with the selection committee&apos;s recommendations. Awardees will
                be announced.
              </p>
            </li>
          </ol>
          <h3>Proposals will be scored based on the following criteria: </h3>
          <table className="uk-table uk-table-divider uk-table-responsive">
            <tbody>
              <tr>
                <td>
                  <h4>Significance</h4>
                </td>
                <td>
                  <ul className="uk-list uk-list-bullet">
                    <li>
                      How does the proposed digital data collection contribute critical data needed in the Alzheimer’s
                      Disease field?
                    </li>
                    <li>Is the team addressing a real problem/need in AD/ADRD research or healthcare?</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Innovation</h4>
                </td>
                <td>
                  <ul className="uk-list uk-list-bullet">
                    <li>
                      Does the proposal demonstrate how this data will open the door to better early
                      detection/diagnosis, phenotypes, predicting prognosis, monitoring disease progression and/or
                      treatment (longitudinal), and optimizing clinical trials in AD/ADRD?
                    </li>
                    <li>
                      Could this project lead to the development of a validated digital biomarker (biomarkers can
                      include diagnostic, monitoring, predictive, prognostic, and susceptibility/risk factors) in
                      research and clinical settings?{" "}
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Feasibility</h4>
                </td>
                <td>
                  <ul className="uk-list uk-list-bullet">
                    <li>Does the project have a realistic plan and timeline for execution of the solution?</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <h4>Scalability</h4>
                </td>
                <td>
                  <ul className="uk-list uk-list-bullet">
                    <li>Does the project design allow for scalability across the ADRC Program and beyond?</li>
                  </ul>
                </td>
              </tr>
              {/* <tr>
                <td>
                  <h4>Accessibility & Equity</h4>
                </td>
                <td>
                  <ul className="uk-list uk-list-bullet">
                    <li>Does this project enable AD/ADRD research and discovery to be more inclusive?</li>
                  </ul>
                </td>
              </tr> */}
            </tbody>
          </table>
          <h3>Review Committee</h3>
          <p>
            Our review committee is made up of experts in scalable digital technologies from across academia, industry,
            and government. Each application will be scored by 2-3 committee members and assigned an average score.
          </p>
        </Prose>
        <ToTop />
      </SectionDefault>

      <SectionDefault id="apply" subheading="How to Apply">
        <section>
          <h3>1. Carefully review the RFA linked here</h3>
          <div className="uk-text-center ">
            <a
              href="https://files.alz.washington.edu/grants/nacc_gv_digital_biomarker_pilots_rfa.pdf"
              className="uk-text-underline uk-text-primary bolder text-body"
            >
              Request for Applications (RFA)
            </a>
            <p className="uk-text-italic">Application deadline: February 21, 2024</p>
          </div>
        </section>

        <section className="uk-margin-large-top">
          <h3>
            2. Review the mission statement, application restrictions and review policies, and funding policies below
          </h3>
          <AccordionLite>
            <AccordionItemLite buttonText="Mission Statement">
              <ul className="uk-list uk-list-bullet">
                <li>
                  The mission of the National Alzheimer&apos;s Coordinating Center (NACC) and Gates Ventures
                  Alzheimer&apos;s Disease and Related Dementias (AD/ADRD) Digital Biomarker Pilot (DBP) Awards is to
                  accelerate innovative digital data collection and sharing across the Alzheimer Disease Research Center
                  (ADRC) Program to accelerate Alzheimer&apos;s Disease and Related Dementias (AD/ADRD) research and
                  discovery.
                </li>
                <li>
                  The NACC and Gates Ventures AD/ADRD DBP Awards are seeking to fulfill this mission by providing
                  funding for pilot projects that leverage technology to enable richer data collection with less burden
                  for participants and ADRCs and that advance the development and validation of digital biomarkers. As a
                  public charity, the DBP Awards funding must be used specifically for an approved scientific project
                  that advances this stated mission.
                </li>
              </ul>
            </AccordionItemLite>
            <AccordionItemLite buttonText="Application submission restrictions">
              <ul className="uk-list uk-list-bullet">
                <li>Any application not meeting the criteria described above will not be reviewed.</li>
                <li>
                  No person involved in the review of applications may be part of a team submitting an application.
                </li>
                <li>
                  <span className="bolder">Page Limits:</span> 1-page project overview, 6-page research strategy
                  (references are not included in this page limit)
                </li>
                <li>
                  <span className="bolder">Format requirements:</span> 12-pt minimum font size, margins no smaller than
                  0.5-inch, PDF format.
                </li>
                <li className="bolder">No appendices will be accepted</li>
              </ul>
            </AccordionItemLite>
            <AccordionItemLite buttonText="Application review process policies">
              <ul className="uk-list uk-list-bullet">
                <li>All applications will be reviewed by the selection committee.</li>
                <li>
                  All pilot project proposals will be evaluated by the selection committee on scientific and technical
                  merit, level of innovation, and investigator, and organizational capabilities and alignment with the
                  goals of the RFA.
                </li>
              </ul>
            </AccordionItemLite>
            <AccordionItemLite buttonText="Funding mechanism">
              <ul className="uk-list uk-list-bullet">
                <li>
                  Pilot projects receiving funding will have a subcontract that is awarded through NACC to the
                  partnering ADRCs on the project.
                </li>
              </ul>
            </AccordionItemLite>
            <AccordionItemLite buttonText="Allowable and unallowable costs">
              <ul className="uk-list uk-list-bullet">
                <li>
                  This funding may be provided for approved personnel costs, supplies (e.g., consumables, chemicals,
                  animals), small non-durable equipment up to $2,500 per item, consultants, and participant costs
                  related to the collection of data.
                </li>
                <li>
                  This funding may not be used for cost of living, capital equipment, equipment service contracts,
                  publication costs, or travel (unless pre-approved under special circumstances).
                </li>
                <li>Up to 15% of additional funding will be provided for indirect costs/overhead.</li>
              </ul>
            </AccordionItemLite>
          </AccordionLite>
        </section>

        <section className="uk-margin-large-top">
          <h3>3. Submit your application</h3>
          <div className="uk-flex uk-flex-center uk-margin-large-top">
            <button className="uk-button uk-button-default" disabled>
              2024 Application Closed
            </button>
          </div>
          <p className="uk-text-meta uk-text-center">Application Deadline: February 21, 2024</p>
          <p className="uk-text-lead uk-margin-left uk-margin-bottom">
            Please review the following application instructions and details below:
          </p>
          <AccordionLite>
            <AccordionItemLite buttonText="Application instructions">
              <p>
                After reviewing the detailed instructions below, please navigate to the REDCap application form to
                submit your pilot proposal.
              </p>
              <p className="bolder">This application form will allow you to submit the following:</p>
              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>Application information, includes:</p>
                  <ul className="uk-list uk-list-bullet">
                    <li>Project Title or Primary Institution</li>
                    <li>Principle Investigators </li>
                    <li>Key Personnel </li>
                    <li>ADRC Collaborators</li>
                    <li>IRB approval status </li>
                  </ul>
                </li>
                <li>Full proposal (in PDF format only) </li>
                <li>Supplemental materials (in PDF format only) </li>
              </ul>
            </AccordionItemLite>
            <AccordionItemLite buttonText="Full Proposal Details">
              <p className="bolder">Formatting Requirements:</p>
              <ul className="uk-list uk-list-bullet">
                <li>
                  All six proposal body sections should be compiled into a single PDF and uploaded where indicated in
                  the application form.
                </li>
                <li>Project Overview should not exceed 1 page of written text.</li>
                <li>
                  Sub-sections <code>2a-2g</code> should not exceed 6 pages of written text.
                </li>
                <li>Embed figures in the text.</li>
                <li>Use 12pt. font and 0.5-inch margins.</li>
              </ul>
              <p>
                The Proposal Body should include all six sections{" "}
                <a href="#details" data-uk-scroll="offset: 20" title="details" className="bolder">
                  as detailed here
                </a>
                .
              </p>
            </AccordionItemLite>
            <AccordionItemLite buttonText="Supplemental Materials">
              <p>All of the following materials are optional.</p>
              <p>
                If submitting supplemental materials, compile all the materials into a single PDF and upload as
                &quot;Supplemental Materials.&quot;
              </p>
              <p>These materials can include:</p>
              <ul className="uk-list uk-list-bullet">
                <li>Quotes from vendors or contract research organizations (CROs) </li>
                <li>IRB-ready clinical protocols </li>
              </ul>
            </AccordionItemLite>
          </AccordionLite>
        </section>

        <section className="uk-margin-large-top">
          <h3>4. Review Process</h3>
          <div className="uk-flex uk-flex-middle uk-flex-column">
            <div className="uk-clearfix uk-width-2xlarge">
              <div className="text-body uk-margin-top">
                <p className="uk-text-justify">
                  Proposals will be reviewed by the selection committee after all applications have been received on the
                  due date, <span className="bolder">February 21, 2024</span>. Applicants can expect to hear back on
                  their application status within 1-2 months after the due date.
                </p>
              </div>
            </div>
          </div>
        </section>
        <ToTop />
      </SectionDefault>

      <SectionDefault id="details" subheading="Proposal Body Details">
        <h3>The Proposal Body should include the following six sections:</h3>
        <AccordionLite>
          <AccordionItemLite buttonText="Project overview (1 page limit)">
            <p>
              Provide a brief overview of the pilot proposal. Describe what problem this proposed technology will solve.
              Describe how this proposal will meet the criteria of expanding the collection of richer data with less
              burden for participants and ADRC staff.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Project description (6 page limit)">
            <p>
              The project description is the central part of the proposal and should contain the eight sub-sections
              listed below (indicate each sub-section by number in the proposal).
            </p>
            <ol type="a">
              <li>
                <p className="bolder">Background and Rationale </p>
                <ol type="i">
                  <li>
                    Provide the biological rationale that links the candidate digital measure(s) to disease
                    pathophysiology.
                  </li>
                  <li>
                    Provide the biological rationale that links the candidate biomarker(s) to disease pathophysiology.
                  </li>
                  <li>Discuss the novelty of the proposed approach and its leading context of use (CoU).</li>
                  <li>
                    It is recommended to focus on one CoU, however, if multiple CoU are proposed, please describe
                    additional biomarker categories here and ensure study design will support these additional
                    categories.
                  </li>
                </ol>
              </li>
              <li>
                <p className="bolder">Supporting Data</p>
                <ol type="i">
                  <li>Provide relevant supporting data.</li>
                  <li>
                    Include data that demonstrates how the candidate biomarker(s) is connected to the disease process.
                  </li>
                  <li>
                    Provide data for the analytical method such as sensitivity, specificity, accuracy, parallelism,
                    precision, sample stability, and other characteristics
                  </li>
                </ol>
              </li>
              <li>
                <p className="bolder">Project Plan and Objectives</p>
                <ol type="i">
                  <li>
                    Objectives: List specific aims and milestones with clearly defined go/no-go decision points for
                    advancement of the project.
                  </li>
                  <li>
                    Timeline: Use the Alzheimer’s Disease Drug Discovery Diagnostic Accelerator Project Plan Template
                    (.xlsx) to provide a schedule for the completion of the proposed milestones/deliverables for each
                    quarter of the year for each year of funding.
                  </li>
                  <li>
                    Discuss critical next steps and/or experiments needed to advance the program to attract additional
                    funding/licensing.
                  </li>
                  <li>
                    Outline strategies for commercial scale-up, manufacturing, possible cross-platform compatibility,
                    and regulatory approval, including the timeline for FDA submissions and milestones.
                  </li>
                </ol>
              </li>
              <li>
                <p className="bolder">Experimental Design and Methods</p>
                <ol type="i">
                  <li>Describe sample collection methods, storage, stability, and extraction procedures.</li>
                  <li>Provide details for each analytical method proposed and the measurement methodology.</li>
                  <li>
                    Include possible strategies if issues arise and any plans for the development of combined measures
                    that may provide greater validity than an individual measure.
                  </li>
                  <li>Include the sourcing of all components of the analytical methods proposed.</li>
                  <li>
                    Provide a statistical analysis plan. Include a power analysis to justify the number of participants
                    or samples per group.
                  </li>
                  <li>
                    For validation studies, describe the strategies for maximizing reproducibility, including standard
                    operating procedures for pre-analytical, analytical, and post-analytical stages.
                  </li>
                  <li>Please describe your regulatory and commercialization strategies.</li>
                </ol>
              </li>
              <li>
                <p className="bolder">Description of Investigative Team and Resources</p>
                <ol type="i">
                  <li>
                    Describe the investigative team and explain how specific expertise of each member will contribute to
                    completing the study objectives.
                  </li>
                  <li>
                    Where internal expertise is not available, include a description of external partners (e.g.
                    consultants, contract research organizations (CROs) that will help to execute the experimental work.
                  </li>
                  <li>
                    Discuss the inclusion of any consultants with assay development expertise that were involved in the
                    design of preclinical or clinical studies or the development of the commercialization plan.
                  </li>
                  <li>
                    If applicable, discuss relationships with commercial diagnostics platform companies or plans to
                    partner. Summarize the materials, technologies, and/or expertise provided by these collaborators.
                  </li>
                </ol>
              </li>
              <li>
                <p className="bolder">Intellectual Property</p>
                <ol type="i">
                  <li>Provide information on existing IP and stage of prosecution.</li>
                  <li>
                    If no IP currently exists, describe the projected plan to generate IP; note if you expect the
                    project to generate new IP.
                  </li>
                  <li>Indicate any freedom to operate issues.</li>
                </ol>
              </li>
              <li>
                <p className="bolder">Other Support</p>
                <ol type="i">
                  <li>
                    List other financial support, awarded and pending, and include grant title, principal investigator,
                    percent effort of investigator, granting agency, amount, and projected funding period.
                  </li>
                  <li>
                    Indicate any overlap between the aims or investigator effort from other funding with the proposed
                    work.
                  </li>
                </ol>
              </li>
              <li>
                <p className="bolder">References</p>
                <ol type="i">
                  <li>References do not count towards the 6-page limit.</li>
                </ol>
              </li>
            </ol>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Budget and Justification (no page limit)">
            <ol type="a">
              <li>
                <p className="bolder">Please complete and provide the following forms in the full proposal PDF:</p>
                <ol type="i">
                  <li>
                    PHS398 Form: Complete the template PDF (
                    <a href="https://drive.google.com/uc?export=download&id=1KLryBHt0AawvLLyH0ZMKntUUWo2zBAie">
                      download here
                    </a>
                    ) or Word version (
                    <a href="https://drive.google.com/uc?export=download&id=1p-m0XDzXn-6HW5FoUFnFXTlP08k_hIwq">
                      download here
                    </a>
                    ).{" "}
                    <a href="https://drive.google.com/uc?export=download&id=125H-WOpYk5Wi7E9ZC7-CGWJfBwkSAe9R">
                      Download instructions here
                    </a>
                    .
                  </li>
                  <li>
                    Budget and Justification: Complete the template and provide a brief justification for each line
                    item.{" "}
                    <a href="https://drive.google.com/uc?export=download&id=1O9YERK7esK5tpWe__i1BPsC5Y_xHQsDK">
                      Download the template here
                    </a>
                    . <span className="bolder">NOTE</span>: You will also be asked to submit this as a CSV file in a
                    separate location in the application.
                  </li>
                </ol>
              </li>
              <li>
                <p className="bolder">
                  Proposals must outline how they will spend $250K to $1M in direct costs. Additional funding will be
                  provided for indirect costs (up to 15%)
                </p>
                <ol type="i">
                  <li>Proposals do not need to provide budget details for NACC to ingest and share data.</li>
                  <li>Please review permissible costs listed in the “Before Getting Started” section above.</li>
                </ol>
              </li>
            </ol>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Biographical Information (no page limit)">
            <ol type="a">
              <li>
                Include a{" "}
                <a href="https://grants.nih.gov/grants/forms/biosketch-blank-format-rev-10-2021.docx">NIH biosketch</a>{" "}
                for each of the key personnel listed on this project.
              </li>
              <li>
                For instructions, please visit:{" "}
                <a href="https://grants.nih.gov/grants/forms/biosketch.htm">
                  https://grants.nih.gov/grants/forms/biosketch.htm
                </a>
              </li>
            </ol>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Study Population Worksheet (no page limit)">
            <ol type="a">
              <li>
                Complete the Study Population Worksheet.{" "}
                <a href="https://drive.google.com/uc?export=download&id=1-izq3o7q5KFYx14D7RwMfOeF54qdjR5P">
                  Download the template here
                </a>
                .
              </li>
              <li>
                If using specimens from an existing cohort, a letter of support from the PI of the study is required.
              </li>
            </ol>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Letters of Support (no page limit)">
            <p>Letters of support from ADRC’s should be included as part of your proposal.</p>
          </AccordionItemLite>
        </AccordionLite>
        <ToTop />
      </SectionDefault>

      <SectionDefault subheading="Contact Us">
        <Prose>
          <p className="uk-margin-remove-bottom">
            Please send all questions to{" "}
            <a className="bolder" href="mailto:naccmail@uw.edu">
              naccmail@uw.edu
            </a>{" "}
            and the NACC team will respond to you within 1-3 business days.
          </p>
          <div className="uk-padding-small uk-border-rounded uk-text-center uk-width-1-1">
            <a
              className="uk-button uk-button-primary uk-padding-left uk-padding-right bolder "
              href="mailto:naccmail@uw.edu"
            >
              Contact Us
            </a>
          </div>
          <p>
            Are you a technology or industry partner interested in being connected with ADRCs who are looking for
            partners? Contact NACC via the button above.
          </p>
        </Prose>
        <ToTop />
      </SectionDefault>

      <SectionDefault subheading="Partner Information">
        <Prose>
          <section>
            <h3>About the ADRC Program</h3>
            <p>
              The National Institute on Aging (NIA) funds 33 Alzheimer&apos;s Disease Research Centers (ADRCs) at major
              medical institutions across the United States. Researchers at these Centers are working to translate
              research advances into improved diagnosis and care for people with Alzheimer&apos;s disease, as well as
              working to find a treatment or way to prevent Alzheimer&apos;s and other types of dementia.
            </p>
            <div className="uk-flex uk-flex-column uk-flex-bottom">
              <StaticImage
                src="../../images/partner-logos/nih-logo.png"
                alt="NIH"
                height={70}
                class="uk-width-1-2@m uk-margin-bottom"
              />
              <div>
                <a
                  href="https://www.nia.nih.gov/health/alzheimers-disease-research-centers"
                  className="bolder"
                  title="ADRC Program"
                >
                  Learn more about the ADRC Program here
                  <FontAwesomeIcon icon={faArrowRight} size="1x" className="uk-margin-small-left"></FontAwesomeIcon>
                </a>
              </div>
            </div>
          </section>
          <section className="uk-margin-large-top">
            <h3>About NACC</h3>
            <p>
              The National Alzheimer&apos;s Coordinating Center (NACC) functions as the centralized data repository, and
              collaboration and communication hub for the National Institute of Aging&apos;s (NIA&apos;s)
              Alzheimer&apos;s Disease and Research Centers (ADRC) Program, which currently includes 33 centers and 4
              exploratory centers across the United States.
            </p>
            <p>
              The National Alzheimer&apos;s Coordinating Center was established in 1999 by the National Institute on
              Aging/NIH to facilitate collaborative research. Using data collected from NIA-funded Alzheimer&apos;s
              Disease Research Centers (ADRCs) across the United States, NACC has developed and maintains a large
              relational database of standardized clinical and neuropathological research data. In partnership with the
              Alzheimer&apos;s Disease Genetics Consortium (ADGC), the National Centralized Repository for
              Alzheimer&apos;s Disease and Related Disorders (NCRAD), and the NIA Genetics of Alzheimer&apos;s Disease
              Data Storage Site (NIAGADS), NACC provides a valuable resource for both exploratory and explanatory
              Alzheimer&apos;s disease research. NACC data are freely available to all researchers.
            </p>
            <div className="uk-flex uk-flex-column uk-flex-top">
              <div className="uk-width-1-3@m">
                <StaticImage
                  src="../../images/nacc-logo.png"
                  alt="NACC"
                  height={150}
                  // width={100}
                  class="uk-object-contain uk-margin-bottom"
                />
              </div>
              <div>
                <Link to="/nacc-collaborations/about-nacc" className="bolder">
                  Learn more about NACC and NACC Data here
                  <FontAwesomeIcon icon={faArrowRight} size="1x" className="uk-margin-small-left"></FontAwesomeIcon>
                </Link>
              </div>
            </div>
          </section>
          <section className="uk-margin-large-top">
            <h3>About Gates Ventures</h3>
            <p>
              Gates Ventures is the private Executive office of Microsoft co-founder and philanthropist Bill Gates and
              was founded 2008 in Kirkland, Washington, United States. It comprises his personal staff, a think tank on
              problems of health and global development, and a technology investment portfolio.
            </p>
            <div className="uk-flex uk-flex-column uk-flex-bottom">
              <div className="uk-width-1-3@m">
                <StaticImage
                  src="../../images/partner-logos/gates-ventures-logo.png"
                  alt="Gates Ventures"
                  height={80}
                  // width={100}
                  class="uk-object-contain uk-margin-bottom"
                />
              </div>
              <div>
                <a href="https://www.gatesnotes.com/" className="bolder" title="Gates Ventures">
                  Learn more about Gates Ventures here
                  <FontAwesomeIcon icon={faArrowRight} size="1x" className="uk-margin-small-left"></FontAwesomeIcon>
                </a>
              </div>
            </div>
          </section>
        </Prose>
        <ToTop />
      </SectionDefault>

      <SectionDefault subheading="FAQs">
        <h3>Program and Program Partners</h3>
        <AccordionLite>
          <AccordionItemLite buttonText="Is EEG data included in the (NACC) database?">
            <p>
              EEG data is not currently included in NACC’s dataset.{" "}
              <Link to="/requesting-data/nacc-data">Learn more about NACC data here</Link>.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Will this opportunity be repeated next year?">
            <p>
              This is a new program launched by NACC in collaboration with Gates Ventures. We have yet to determine
              whether the program will be continued in following years.
            </p>
          </AccordionItemLite>
        </AccordionLite>

        <h3>Eligibility and Application Requirements</h3>
        <AccordionLite className="left-indicator">
          <AccordionItemLite buttonText="When is travel an approved cost?">
            <p>
              The RFA states that travel may not be an allowable cost unless special circumstances are approved. Special
              circumstances may include necessary travel for project activities integral to data collection or the
              overall project. Please reach out to <a href="mailto:naccmail@uw.edu">naccmail@uw.edu</a> to determine if
              travel costs for your proposal are approved.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Who should I list as the prime sponsor on my grants and finance documentation?">
            <p>
              Please list <strong>University of Washington</strong> – as NACC will be distributing the subawards for
              projects who are awarded funding.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Are non-US based companies eligible for funding?">
            <p>
              Yes! Non-US companies are eligible for funding as long as they have at least two Alzheimer’s Disease
              Research Center (ADRC) Program collaborators.
            </p>
            <p>
              All data generated or used in each pilot project must be made accessible to the research community through
              the National Alzheimer&apos;s Coordinating Center (NACC) Data Platform.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Are postdocs eligible to be the PI on the application?">
            <p>
              If the PI on the application is a postdoc, most institutions will ask for a faculty sponsor when they
              submit and go through their internal approval process.
            </p>
            <p>
              If that is the case for your institution and your proposal is awarded funding, that award may need to be
              listed under the faculty sponsor&apos;s name.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Is the requirement 2 different ADRCS, or can it be 2 different investigators at a single ADRC?">
            <p>At least 2 ADRC collaborators from different institutions are required</p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Are applicants' budgets held to the NIH salary cap?">
            <p>As this grant is not funded by NIH, there is no requirement to adhere to the NIH salary caps.</p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Are sites under the requirement to adhere to the single-site IRB?">
            <p>
              There is no requirement to adhere to the single-site IRB – IRB requirements are met so long as each site
              is clear to collect the data described in the proposal and share this data with NACC.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Can the institutions involved in an application submit the budgets separately for the proposal?">
            <p>
              Each of the four institutions as well as any technology partners on your application can submit a
              separated budget for your application. NACC would then setup subawards for each institution to maximize
              the amount of funding that goes towards the actual research.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText='The requirements for the RFA state that "industry partnerships are strongly encouraged" - should we interpret this statement to mean that we should not apply for the program if we are not currently partnered with a wearable device company?'>
            <p>
              This statement is meant to encourage those applying to have a strong plan for how their pilot proposal
              will be implemented across several piloting sites. An industry partnership or plan that supports this
              would make for a stronger application.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="The application asks for IRB approval that seems to be needed at the time of the application. Can you confirm, expand on this?">
            <p>
              IRB approval is not required as part of the application process, but a stronger application would include
              details and/or a timeline about securing IRB approval.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Regarding the 6-page limit of the research proposal, are f (other support) and g (IP) included in the 6-page limit or can these be added as appendix?">
            <p>2a-2g, including ‘other support’ and ‘IP’ are meant to be included in the 6-page research proposal.</p>
          </AccordionItemLite>
        </AccordionLite>

        <h3>Partnerships between Academia and Industry</h3>
        <AccordionLite>
          <AccordionItemLite buttonText="Are there any specific requirements to put a foreign (non-US) subaward in place?">
            <p>
              Yes, there are several requirements that NACC/University of Washington must follow to set up subawards
              with foreign entities. Please reach out to <a href="mailto:naccmail@uw.edu">naccmail@uw.edu</a> for more
              information.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="What mechanism does NACC have for tech companies to pitch new technologies/proposals to ADRCs?">
            <p>
              For the purposes of facilitating partnerships with the purpose of submitting a pilot proposal only – NACC
              will connect tech companies with ADRC’s who have indicated their interest in being approached by tech
              companies looking for partners for the NACC & Gates Ventures Digital Data Pilot Program. Email us at{" "}
              <a href="mailto:naccmail@uw.edu" className="bolder">
                naccmail@uw.edu
              </a>
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Should ADRC researchers also email NACC to get connected with tech companies?">
            <p>
              NACC does not currently have a list of possible tech companies to partner with, but feel free to reach out
              to{" "}
              <a href="mailto:naccmail@uw.edu" className="bolder">
                naccmail@uw.edu
              </a>{" "}
              and we will connect with the Clinical Task Force Technology Workgroup to determine if any connections can
              be made.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Can we partner with international investigators? Can you speak about the issue of tech companies that share IP secrets with certain foreign countries being barred from US SBIR funding?">
            <p>
              All applicants are welcome, including international collaborators. As long as the proposal includes at
              least 2 collaborators from a member of an ADRC.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="What would an ADRC partnership look like for a company with a focused proposal already?">
            <p>
              This is highly dependent on the ADRC(s) involved. Some may be open to simply joining as a pilot site while
              others will want to be more involved in the proposal writing process.
            </p>
          </AccordionItemLite>
        </AccordionLite>

        <h3>Data and Data Sharing</h3>
        <AccordionLite>
          <AccordionItemLite buttonText="Will EEG data be considered a digital biomarker?">
            <p>Yes, it could be.</p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Could you define Raw Digital files? Is that the raw sensor data or may that be up to the company's discretion?">
            <p>
              Yes, raw digital files include raw sensor data; a company will need to decide what is possible while
              protecting IP. For example, sharing raw sensor data but not any derived measures that rely on proprietary
              algorithms would fulfill the criteria of sharing raw digital data files without exposing company secrets.
            </p>
          </AccordionItemLite>
          <AccordionItemLite buttonText="Are there any system requirements for sharing data in NACC’s cloud?">
            <ul className="uk-list uk-list-bullet">
              <li>
                All data generated or used in each pilot project must be made accessible to the research community
                through the National Alzheimer&apos;s Coordinating Center (NACC) Data Platform.
              </li>
              <li>NACCID must be affiliated with data</li>
              <li>Documentation on datatype, metadata descriptors, etc. Should be provided</li>
              <li>Tooling & code necessary for QC/processing of data should be provided </li>
            </ul>
          </AccordionItemLite>
          <AccordionItemLite buttonText="In terms of confidential data sharing, privacy and operation: is the plan to stand up a shared data commons for these initiatives that is based on enforced standards and leveraging cutting-edge technologies such as homomorphic encryption and zero-knowledge proofs, etc.? Or is every initiative going to be using bespoke data collection doing their best to adhere to data sharing standards?  As a negative counter-example - during the Covid-19 defense, the various initiatives doing voice-based diagnostics were collecting slightly different data sets for no scientific reason, resulting in the failure of all of their respective machine learning approaches due to limited data - whereas if there were clearly defined and enforced standards their data could have been shared and strengthened each of their proprietary approaches (without harming their IP, etc.)">
            <p>
              NACC is currently working with the Global Research Integration Platform team to develop tools to enable
              better privacy protection, harmonization, and data management and processing. These open source tools will
              be made available on the NACC website with the assumption that these are first generation tools that the
              scientific community will iterate on since there are no currently accepted gold standards. Since different
              data types in general, and digital data in particular will also have nuanced differences, it is likely
              that there will be a hybrid between recommended approaches that can be used uniformly versus those that
              will need local customization.
            </p>
          </AccordionItemLite>
        </AccordionLite>
        <ToTop />
      </SectionDefault>
    </GlobalLayout>
  );
}
